import request from "../helpers/request";
import { AuthHeader } from "../helpers";

export {
  getSuppliers,
  getCustomerTypes,
  createLocation,
  getLocationsByCustomerId,
  getLocationById,
  updateLocation,
  deleteLocationById
};

function getSuppliers() {
  return request({
    url: "suppliers/",
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getCustomerTypes() {
  return request({
    url: "customer-typing/",
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function createLocation(
  customer_id,
  name,
  suppliers,
  customer_type,
  username,
  address,
  postal,
  phone,
  email,
  city,
  contact,
  password
) {
  return request({
    url: "locations/create",
    method: "POST",
    data: {
      customer_id: customer_id,
      name: name,
      suppliers: suppliers,
      customer_type: customer_type,
      username: username,
      address: address,
      postal: postal,
      phone: phone,
      email: email,
      city: city,
      contact: contact,
      password: password
    },
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function updateLocation(
  locationId,
  name,
  suppliers,
  customer_type,
  username,
  address,
  postal,
  phone,
  email,
  city,
  contact,
  password
) {
  return request({
    url: "locations/update/" + locationId,
    method: "PUT",
    data: {
      name: name,
      suppliers: suppliers,
      customer_type: customer_type,
      username: username,
      address: address,
      postal: postal,
      phone: phone,
      email: email,
      city: city,
      contact: contact,
      password: password
    },
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getLocationsByCustomerId(customer_id) {
  return request({
    url: `locations/${customer_id}`,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getLocationById(locationId) {
  return request({
    url: `locations/location/${locationId}`,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function deleteLocationById(locationId) {
  return request({
    url: `locations/${locationId}`,
    method: "DELETE",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  })
}
